import { useState } from "react";
import RecentIncentivesSection from "./RecentIncentivesSection";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import IncentiveDetailsHeader from "./IncentiveDetailsHeader";
import IncentiveDetailsSection from "./IncentiveDetailsSection";
import { useEffect } from "react";
import { getBesIncentives } from "../../apis/requests";
import Popup from "../../ReusableFunctions/Popup";
import { BES_INCENTIVE_STATUS } from "../../appConstants";
import { updateIncentiveStatus } from "../../apis/incentives/incentives";
import Loading from "../../ReusableFunctions/Loader";

export default function IncentiveOverView() {
  const [incentives, setIncentives] = useState([]);
  const { user } = useSelector((state) => state.user);
  const [initialLoad, setInitialLoad] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [recentIncentiveLoading, setRecentIncentiveLoading] = useState(false);
  const [previousIncentivesLoading, setpreviousIncentivesLoading] = useState(false);
  const { state } = useLocation();
  const [markAsPaidPopup, setMarkAsPaidPopup] = useState(false);
  const [selectedIncentive, setselectedIncentive] = useState(undefined);
  const [filters, setFilters] = useState(state?.filters || {});
  const [localIncentive, setLocalIncentive] = useState({});
  const [incentiveStatus, setIncentiveStatus] = useState(selectedIncentive?.status)

  const getIncentivesAPI = async (
    pageSize,
    pageNumber,
    searchQuery,
    status,
    fromDate,
    toDate
  ) => {
    try {
      setIsLoading(true);
      const { data } = await getBesIncentives(
        pageNumber,
        pageSize,
        searchQuery,
        status,
        fromDate,
        toDate,
      );
      setIncentives(data.incentives);
      setselectedIncentive(state?.incentive);
      setIncentiveStatus(state?.incentive?.status)
      setIsLoading(false);
    } catch (err) {

      setIsLoading(false);
      Popup.alert("Error", err, "ERROR");
    }
  };


  const getInitalData = async () => {
    try {
      await getIncentivesAPI(
        filters.pageSize,
        filters?.pageNumber,
        filters.searchQuery,
        filters.status,
        filters?.fromDate ? new Date(new Date(filters?.fromDate).setHours(0, 0, 0, 0)).toISOString() : undefined,
        filters?.toDate ? new Date(new Date(filters?.toDate).setHours(23, 59, 59, 999)).toISOString() : undefined,
      );
    } catch (error) {
      console.log("error", error);
    }
  };

  const fetchPreviousIncentives = async (pageNumber) => {
    if (pageNumber < 1) return;
    try {
      setRecentIncentiveLoading(true);
      const { data } = await getBesIncentives(
        pageNumber,
        filters.pageSize,
        filters.searchQuery,
        filters.status,
        filters?.fromDate ? new Date(new Date(filters?.fromDate).setHours(0, 0, 0, 0)).toISOString() : undefined,
        filters?.toDate ? new Date(new Date(filters?.toDate).setHours(23, 59, 59, 999)).toISOString() : undefined

      );

      if (data?.incentives?.length > 0) {
        setIncentives((prevRequests) => [...data.incentives, ...prevRequests]);
      }
    } catch (err) {
      Popup.alert("Error", err, "ERROR");
    } finally {
      setTimeout(() => setRecentIncentiveLoading(false), 500);
    }
  }


  const fetchMoreIncentives = async (pageNumber) => {
    if (!hasMore) return;
    setRecentIncentiveLoading(true);
    try {

      const { data } = await getBesIncentives(
        pageNumber,
        filters.pageSize,
        filters.searchQuery,
        filters.status,
        filters?.fromDate ? new Date(new Date(filters?.fromDate).setHours(0, 0, 0, 0)).toISOString() : undefined,
        filters?.toDate ? new Date(new Date(filters?.toDate).setHours(23, 59, 59, 999)).toISOString() : undefined

      );

      if (data.incentives.length > 0) {
        setIncentives((prevRequests) => [...prevRequests, ...data.incentives]);
        setFilters((prevFilters) => ({
          ...prevFilters,
          pageNumber: pageNumber
        }))
      } else {
        setHasMore(false);
      }
    } catch (err) {
      Popup.alert("Error", err, "ERROR");
    } finally {
      setRecentIncentiveLoading(false);
    }
  };


  const UpdateIncentiveAPI = async (id, status) => {
    try {
      Loading.set(true);
      const { updatedIncentive } = await updateIncentiveStatus(id, status)
      const updatedIncentives = incentives.map((inc) =>
        inc.id === updatedIncentive.id
          ? { ...inc, status: updatedIncentive?.status }
          : inc
      );
      setIncentiveStatus(updatedIncentive.status);
      setIncentives(updatedIncentives);
      Popup.alert("Success", "Incentive status updated successfully.", 'SUCCESS')

    } catch (err) {
      Popup.alert("ERROR", "something went wrong while uppadting incentive status", "ERROR")
    } finally {
      Loading.set(false);
    }
  }


  useEffect(() => {
    if (state?.incentive) {
      if (initialLoad) {
        getInitalData();
        setInitialLoad(false);
      }
    }
  }, [state?.request]);

  return (
    <div className="w-full px-10 py-8 bg-[#D9D9D9] h-[100%] font-manrope ">
      <div className="bg-[#FFFFFF] border border-[#D9D9D9] h-[500px] min-h-[100%] flex rounded-[15px] ">
        {!state?.hideRecentIncentiveSection &&
          <div className="w-[30%]">
            <RecentIncentivesSection
              isLoading={recentIncentiveLoading}
              previousIncentivesLoading={previousIncentivesLoading}
              filters={filters}
              selectedIncentive={selectedIncentive}
              incentives={incentives}
              hasMore={hasMore}
              fetchPreviousIncentives={fetchPreviousIncentives}
              fetchMoreIncentives={fetchMoreIncentives}
              handleIncentiveClick={(incentive) => {
                if (incentive?.id === selectedIncentive?.id) {
                  return;
                }
                setselectedIncentive(incentive);
                setIncentiveStatus(incentive?.status)
              }}
            />
          </div>
        }
        <div className={`w-[100%] flex flex-col `}>
          <IncentiveDetailsHeader
            incentiveStatus={incentiveStatus}
            handleStatusChange={(status) => {
              if (status === selectedIncentive.status) {
                return;
              }
              if (status === BES_INCENTIVE_STATUS.SUBMITTED) {
                setMarkAsPaidPopup(true);
                return;
              }
              UpdateIncentiveAPI(selectedIncentive.id, status);
              setIncentiveStatus(() => status)
            }}
            setMarkAsPaidPopup={setMarkAsPaidPopup}
            options={
              incentiveStatus === BES_INCENTIVE_STATUS.SETTELED
               ? [BES_INCENTIVE_STATUS.SETTELED]:incentiveStatus===BES_INCENTIVE_STATUS.SUBMITTED
               ?[BES_INCENTIVE_STATUS.SUBMITTED]:[BES_INCENTIVE_STATUS.PENDING, BES_INCENTIVE_STATUS.SUBMITTED]
            }
          />
          <div className="w-full  max-h-full overflow-y-scroll h-full  flex">
            <IncentiveDetailsSection
              localIncentive={localIncentive}
              isLoading={isLoading}
              setLocalIncentive={setLocalIncentive}
              incentive={selectedIncentive}
              markAsPaidPopup={markAsPaidPopup}
              setMarkAsPaidPopup={setMarkAsPaidPopup}
              onResetStatus={() => { }}
              onIncentiveUpdate={async (updatedIncentive) => {
                const updatedIncentives = incentives.map((inc) =>
                  inc.id === updatedIncentive.id
                    ? { ...inc, status: updatedIncentive?.status, payment_mode: updatedIncentive?.payment_mode, payment_proof: updatedIncentive?.payment_proof }
                    : inc
                );
                setselectedIncentive((prevDetails) => ({ ...prevDetails, status: updatedIncentive.status }))
                setIncentives(updatedIncentives);
                setIncentiveStatus(updatedIncentive?.status)
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
